module.exports = __webpack_public_path__ + "img/schinkenkaesetoast.39662d36.png";